// From the context module, not useFundraisingTracking: that one pulls the fundraising-core barrel
// into every act page.
import { FUNDRAISING_TRACKING_ORG_KEY } from 'fundraising-ui/composables/fundraisingTrackingContext'
import type { SiteLang, SiteOrg } from '~/types/env'

// The org and language every fundraising-ui flow tags its tracking and conversions with: this
// deploy's. /gava and /minnesgava provide their own on top, following the page's i18n locale.
export default defineNuxtPlugin(nuxtApp => {
  const { SITE_ORG, SITE_LANG } = useRuntimeConfig().public as {
    SITE_ORG: SiteOrg
    SITE_LANG: SiteLang
  }
  nuxtApp.vueApp.provide(FUNDRAISING_TRACKING_ORG_KEY, { org: SITE_ORG, lang: SITE_LANG })
})
